import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import { InjectionToken } from '@angular/core';
import * as actions from './header-create-menu.actions';

export const headerCreateMenuFeatureKey = 'headerCreateMenu';

export interface State {
  isLoading: boolean;
  uploadedDesignsCount: number;
}

export const initialState: State = {
  isLoading: false,
  uploadedDesignsCount: 0,
};

export const headerCreateMenuReducerToken = new InjectionToken<ActionReducerMap<State>>('header create menu reducer');

export const reducer = createReducer(
  initialState,
  on(actions.loadUploadDesignLeftLimits, state => ({
    ...state,
    isLoading: true,
  })),
  on(actions.uploadMetadataSuccess, (state, { metadata }) => {
    const [limitMetadata] = metadata;
    const uploadedDesignsCount = +limitMetadata?.value || 0;

    return {
      ...state,
      uploadedDesignsCount,
      isLoading: false,
    };
  }),
);
